require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./chimie-et-gnie-chimique-edch-2-3-4-4.json") })
        }
      }, "path---chimie-et-gnie-chimique-edch-2-3-4-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---chimie-et-gnie-chimique-edch-2-3-4-4!./.cache/json/chimie-et-gnie-chimique-edch-2-3-4-4.json
// module id = 370
// module chunks = 231608221292675